import { Component, OnInit , AfterViewInit , Input } from '@angular/core';
import {CommonService} from "../common.service";
@Component({
  selector: 'app-big-guide',
  templateUrl: './big-guide.component.html',
  styleUrls: ['./big-guide.component.css']
})
export class BigGuideComponent implements OnInit , AfterViewInit{
    @Input() content:string;
    isHarmonyOS = false; //是否鸿蒙系统

  constructor(private commonService: CommonService) { }

  ngOnInit() {
    this.isHarmonyOS = this.commonService.isHarmonyOS();
  }

  ngAfterViewInit(){

  }

}



// WEBPACK FOOTER //
// ./src/app/big-guide/big-guide.component.ts